import React, { useState, useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import axios from 'axios';

const API = 'https://csksportswear.in/backend/api';

function UserManagement() {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [showPasswordModal, setShowPasswordModal] = useState(false);
  const [editUser, setEditUser] = useState(null);
  const [selectedUser, setSelectedUser] = useState(null);
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [newPassword, setNewPassword] = useState('');
  const [form, setForm] = useState({ name: '', password: '', role: 'cashier', status: 'active' });
  const navigate = useNavigate();
  const token = localStorage.getItem('csk_token');
  const currentUser = JSON.parse(localStorage.getItem('csk_user') || '{}');

  useEffect(() => {
    if (!token) { navigate('/login'); return; }
    if (currentUser.role !== 'admin') { navigate('/admin/dashboard'); return; }
    fetchUsers();
  }, []);

  const fetchUsers = async () => {
    try {
      const res = await axios.get(`${API}/users.php?action=list`, { headers: { Authorization: `Bearer ${token}` } });
      if (res.data.success) setUsers(res.data.data);
    } catch (err) { console.error(err); }
    finally { setLoading(false); }
  };

  const handleSubmit = async () => {
    if (!form.name) { alert('Name required!'); return; }
    if (!editUser && !form.password) { alert('Password required!'); return; }
    if (!editUser && form.password.length < 6) { alert('Password min 6 characters!'); return; }
    try {
      if (editUser) {
        await axios.post(`${API}/users.php?action=update`, { id: editUser.id, name: form.name, role: form.role, status: form.status }, { headers: { Authorization: `Bearer ${token}` } });
      } else {
        await axios.post(`${API}/users.php?action=create`, { name: form.name, password: form.password, role: form.role }, { headers: { Authorization: `Bearer ${token}` } });
      }
      setShowModal(false); setEditUser(null);
      setForm({ name: '', password: '', role: 'cashier', status: 'active' });
      fetchUsers();
    } catch (err) {
      alert(err.response?.data?.error || 'Error saving user!');
    }
  };

  const handleEdit = (user) => {
    setEditUser(user);
    setForm({ name: user.name, password: '', role: user.role, status: user.status });
    setShowModal(true);
  };

  const handleDelete = async (id) => {
    if (id === parseInt(currentUser.id)) { alert('Cannot delete yourself!'); return; }
    if (!window.confirm('Delete this user?')) return;
    try {
      await axios.get(`${API}/users.php?action=delete&id=${id}`, { headers: { Authorization: `Bearer ${token}` } });
      fetchUsers();
    } catch (err) { alert('Error!'); }
  };

  const handleResetPassword = async () => {
    if (!newPassword || newPassword.length < 6) { alert('Min 6 characters!'); return; }
    try {
      await axios.post(`${API}/users.php?action=reset`, { id: selectedUser.id, password: newPassword }, { headers: { Authorization: `Bearer ${token}` } });
      setShowPasswordModal(false); setNewPassword('');
      alert('Password reset successfully!');
    } catch (err) { alert('Error!'); }
  };

  const getRoleColor = (role) => {
    if (role === 'admin') return { bg: 'rgba(220,38,38,0.1)', color: '#DC2626' };
    if (role === 'manager') return { bg: 'rgba(245,158,11,0.1)', color: '#F59E0B' };
    return { bg: 'rgba(0,102,255,0.1)', color: '#0066FF' };
  };

  const inputStyle = { width: '100%', padding: '10px 14px', background: 'rgba(255,255,255,0.05)', border: '1px solid rgba(255,255,255,0.1)', borderRadius: '8px', color: 'white', fontSize: '14px', outline: 'none', boxSizing: 'border-box' };

  const menuItems = [
    { path: '/admin/dashboard', label: 'Dashboard', icon: '🏠' },
    { path: '/admin/inventory', label: 'Inventory', icon: '📦' },
    { path: '/admin/pos', label: 'POS Billing', icon: '🧾' },
    { path: '/admin/reports', label: 'Reports', icon: '📊' },
    { path: '/admin/gallery', label: 'Gallery', icon: '🖼️' },
    { path: '/admin/enquiries', label: 'Enquiries', icon: '📩' },
    { path: '/admin/settings', label: 'Settings', icon: '⚙️' },
    { path: '/admin/users', label: 'Users', icon: '👥' },
  ];

  return (
    <div style={{ display: 'flex', minHeight: '100vh', background: '#0A0A0A', fontFamily: 'Inter, sans-serif' }}>
      <style>{`
        .usr-sidebar { width: 200px; background: #000; border-right: 1px solid rgba(255,255,255,0.08); display: flex; flex-direction: column; position: fixed; top: 0; left: 0; bottom: 0; z-index: 100; transition: transform 0.3s ease; }
        .usr-main { margin-left: 200px; flex: 1; padding: 32px; }
        .usr-mobile-hdr { display: none; background: #000; padding: 12px 16px; position: fixed; top: 0; left: 0; right: 0; z-index: 99; border-bottom: 1px solid rgba(255,255,255,0.08); align-items: center; justify-content: space-between; }
        .usr-overlay { display: none; position: fixed; inset: 0; background: rgba(0,0,0,0.7); z-index: 99; }
        @media (max-width: 768px) { .usr-sidebar { transform: translateX(-100%); } .usr-sidebar.open { transform: translateX(0); } .usr-main { margin-left: 0; padding: 72px 16px 16px; } .usr-mobile-hdr { display: flex; } .usr-overlay.show { display: block; } }
        .usr-nav-link { display: flex; align-items: center; gap: 10px; padding: 12px 16px; color: #475569; font-size: 13px; font-weight: 500; text-decoration: none; border-left: 3px solid transparent; transition: all 0.2s; }
        .usr-nav-link:hover { color: white; background: rgba(255,255,255,0.05); }
        .usr-nav-link.active { color: white; background: rgba(0,102,255,0.1); border-left-color: #0066FF; }
      `}</style>

      <div className="usr-mobile-hdr">
        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
          <span style={{ color: '#DC2626', fontSize: '20px' }}>★</span>
          <span style={{ fontFamily: 'Montserrat', fontSize: '14px', fontWeight: 800, color: 'white' }}>CSK</span>
        </div>
        <button onClick={() => setSidebarOpen(!sidebarOpen)} style={{ background: 'none', border: 'none', color: 'white', fontSize: '22px', cursor: 'pointer' }}>☰</button>
      </div>

      <div className={`usr-overlay ${sidebarOpen ? 'show' : ''}`} onClick={() => setSidebarOpen(false)} />

      <div className={`usr-sidebar ${sidebarOpen ? 'open' : ''}`}>
        <div style={{ padding: '16px', borderBottom: '1px solid rgba(255,255,255,0.08)' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            <span style={{ color: '#DC2626', fontSize: '20px' }}>★</span>
            <div>
              <div style={{ fontFamily: 'Montserrat', fontSize: '13px', fontWeight: 800, letterSpacing: '2px', color: 'white' }}>CSK</div>
              <div style={{ fontSize: '8px', color: '#475569', letterSpacing: '1px' }}>ADMIN PANEL</div>
            </div>
          </div>
        </div>
        <div style={{ padding: '12px 16px', borderBottom: '1px solid rgba(255,255,255,0.08)' }}>
          <div style={{ fontSize: '13px', fontWeight: 600, color: 'white' }}>{currentUser.name}</div>
          <div style={{ fontSize: '11px', color: '#0066FF', textTransform: 'uppercase', letterSpacing: '1px' }}>{currentUser.role}</div>
        </div>
        <nav style={{ flex: 1, padding: '8px 0' }}>
          {menuItems.map(item => (
            <Link key={item.path} to={item.path} className={`usr-nav-link ${window.location.pathname === item.path ? 'active' : ''}`} onClick={() => setSidebarOpen(false)}>
              <span>{item.icon}</span>{item.label}
            </Link>
          ))}
        </nav>
        <div style={{ padding: '12px', borderTop: '1px solid rgba(255,255,255,0.08)' }}>
          <button onClick={() => { localStorage.clear(); navigate('/login'); }} style={{ width: '100%', padding: '8px', background: 'rgba(220,38,38,0.1)', border: '1px solid rgba(220,38,38,0.3)', borderRadius: '6px', color: '#DC2626', fontSize: '12px', fontWeight: 600, cursor: 'pointer' }}>🚪 Logout</button>
        </div>
      </div>

      <div className="usr-main">
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '24px', flexWrap: 'wrap', gap: '12px' }}>
          <div>
            <h1 style={{ fontFamily: 'Montserrat', fontSize: '28px', fontWeight: 800, color: 'white', marginBottom: '4px' }}>User Management</h1>
            <p style={{ color: '#475569', fontSize: '14px' }}>Manage admin panel users</p>
          </div>
          <button onClick={() => { setEditUser(null); setForm({ name: '', password: '', role: 'cashier', status: 'active' }); setShowModal(true); }} style={{ background: 'linear-gradient(135deg, #0066FF, #0052CC)', color: 'white', padding: '10px 24px', borderRadius: '8px', border: 'none', fontSize: '14px', fontWeight: 700, cursor: 'pointer' }}>+ Add User</button>
        </div>

        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(180px, 1fr))', gap: '16px', marginBottom: '24px' }}>
          {[
            { role: 'Admin', icon: '👑', desc: 'Full access', color: '#DC2626', count: users.filter(u => u.role === 'admin' && u.status === 'active').length },
            { role: 'Manager', icon: '📊', desc: 'Reports + Inventory', color: '#F59E0B', count: users.filter(u => u.role === 'manager' && u.status === 'active').length },
            { role: 'Cashier', icon: '🧾', desc: 'POS Billing only', color: '#0066FF', count: users.filter(u => u.role === 'cashier' && u.status === 'active').length },
          ].map((r, i) => (
            <div key={i} style={{ background: 'rgba(255,255,255,0.03)', border: '1px solid rgba(255,255,255,0.08)', borderRadius: '12px', padding: '20px' }}>
              <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                <div>
                  <div style={{ fontSize: '11px', color: '#475569', marginBottom: '6px', textTransform: 'uppercase', letterSpacing: '1px' }}>{r.role}</div>
                  <div style={{ fontSize: '28px', fontWeight: 800, color: r.color, marginBottom: '4px' }}>{r.count}</div>
                  <div style={{ fontSize: '12px', color: '#475569' }}>{r.desc}</div>
                </div>
                <div style={{ fontSize: '28px' }}>{r.icon}</div>
              </div>
            </div>
          ))}
        </div>

        {loading ? (
          <div style={{ textAlign: 'center', color: '#475569', padding: '60px' }}>Loading...</div>
        ) : (
          <div style={{ background: 'rgba(255,255,255,0.03)', border: '1px solid rgba(255,255,255,0.08)', borderRadius: '12px', overflow: 'hidden' }}>
            <div style={{ padding: '16px', borderBottom: '1px solid rgba(255,255,255,0.08)', display: 'flex', justifyContent: 'space-between' }}>
              <h3 style={{ fontFamily: 'Montserrat', fontSize: '16px', fontWeight: 700, color: 'white' }}>All Users</h3>
              <span style={{ color: '#475569', fontSize: '13px' }}>{users.length} users</span>
            </div>
            <div style={{ overflowX: 'auto' }}>
              <table style={{ width: '100%', borderCollapse: 'collapse', minWidth: '500px' }}>
                <thead>
                  <tr style={{ borderBottom: '1px solid rgba(255,255,255,0.08)' }}>
                    {['Name', 'Role', 'Status', 'Created', 'Actions'].map(h => (
                      <th key={h} style={{ padding: '12px 16px', textAlign: 'left', fontSize: '11px', fontWeight: 600, color: '#475569', textTransform: 'uppercase', letterSpacing: '1px' }}>{h}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {users.length === 0 ? (
                    <tr><td colSpan={5} style={{ textAlign: 'center', padding: '40px', color: '#475569' }}>No users found</td></tr>
                  ) : users.map(user => (
                    <tr key={user.id} style={{ borderBottom: '1px solid rgba(255,255,255,0.05)' }}>
                      <td style={{ padding: '14px 16px' }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                          <div style={{ width: '36px', height: '36px', borderRadius: '50%', background: 'rgba(0,102,255,0.2)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '14px', fontWeight: 700, color: '#0066FF' }}>
                            {user.name.charAt(0).toUpperCase()}
                          </div>
                          <div>
                            <div style={{ fontSize: '14px', fontWeight: 600, color: 'white' }}>{user.name}</div>
                            {user.id === parseInt(currentUser.id) && <div style={{ fontSize: '10px', color: '#0066FF' }}>You</div>}
                          </div>
                        </div>
                      </td>
                      <td style={{ padding: '14px 16px' }}>
                        <span style={{ padding: '4px 12px', borderRadius: '50px', fontSize: '11px', fontWeight: 700, textTransform: 'uppercase', background: getRoleColor(user.role).bg, color: getRoleColor(user.role).color }}>{user.role}</span>
                      </td>
                      <td style={{ padding: '14px 16px' }}>
                        <span style={{ padding: '4px 12px', borderRadius: '50px', fontSize: '11px', fontWeight: 600, background: user.status === 'active' ? 'rgba(22,163,74,0.1)' : 'rgba(220,38,38,0.1)', color: user.status === 'active' ? '#16A34A' : '#DC2626' }}>{user.status}</span>
                      </td>
                      <td style={{ padding: '14px 16px', fontSize: '12px', color: '#475569' }}>{new Date(user.created_at).toLocaleDateString('en-IN')}</td>
                      <td style={{ padding: '14px 16px' }}>
                        <div style={{ display: 'flex', gap: '6px', flexWrap: 'wrap' }}>
                          <button onClick={() => handleEdit(user)} style={{ padding: '5px 12px', background: 'rgba(0,102,255,0.1)', border: '1px solid rgba(0,102,255,0.3)', borderRadius: '6px', color: '#0066FF', fontSize: '12px', cursor: 'pointer', fontWeight: 600 }}>Edit</button>
                          <button onClick={() => { setSelectedUser(user); setNewPassword(''); setShowPasswordModal(true); }} style={{ padding: '5px 12px', background: 'rgba(245,158,11,0.1)', border: '1px solid rgba(245,158,11,0.3)', borderRadius: '6px', color: '#F59E0B', fontSize: '12px', cursor: 'pointer', fontWeight: 600 }}>🔑 Reset</button>
                          {user.id !== parseInt(currentUser.id) && (
                            <button onClick={() => handleDelete(user.id)} style={{ padding: '5px 12px', background: 'rgba(220,38,38,0.1)', border: '1px solid rgba(220,38,38,0.3)', borderRadius: '6px', color: '#DC2626', fontSize: '12px', cursor: 'pointer', fontWeight: 600 }}>Del</button>
                          )}
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        )}
      </div>

      {showModal && (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.8)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000, padding: '16px' }}>
          <div style={{ background: '#0D1B2A', border: '1px solid rgba(255,255,255,0.1)', borderRadius: '16px', padding: '32px', width: '100%', maxWidth: '480px' }}>
            <h2 style={{ fontFamily: 'Montserrat', fontSize: '20px', fontWeight: 800, marginBottom: '24px', color: 'white' }}>{editUser ? 'Edit User' : 'Add New User'}</h2>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
              <div>
                <label style={{ display: 'block', fontSize: '12px', fontWeight: 600, marginBottom: '6px', color: '#94A3B8' }}>Username *</label>
                <input type="text" placeholder="Enter username" value={form.name} onChange={e => setForm({ ...form, name: e.target.value })} style={inputStyle} />
              </div>
              {!editUser && (
                <div>
                  <label style={{ display: 'block', fontSize: '12px', fontWeight: 600, marginBottom: '6px', color: '#94A3B8' }}>Password * (min 6 chars)</label>
                  <input type="password" placeholder="Min 6 characters" value={form.password} onChange={e => setForm({ ...form, password: e.target.value })} style={inputStyle} />
                </div>
              )}
              <div>
                <label style={{ display: 'block', fontSize: '12px', fontWeight: 600, marginBottom: '6px', color: '#94A3B8' }}>Role *</label>
                <select value={form.role} onChange={e => setForm({ ...form, role: e.target.value })} style={{ ...inputStyle, background: '#1E293B' }}>
                  <option value="cashier">Cashier — POS only</option>
                  <option value="manager">Manager — Reports + Inventory</option>
                  <option value="admin">Admin — Full Access</option>
                </select>
              </div>
              {editUser && (
                <div>
                  <label style={{ display: 'block', fontSize: '12px', fontWeight: 600, marginBottom: '6px', color: '#94A3B8' }}>Status</label>
                  <select value={form.status} onChange={e => setForm({ ...form, status: e.target.value })} style={{ ...inputStyle, background: '#1E293B' }}>
                    <option value="active">Active</option>
                    <option value="inactive">Inactive</option>
                  </select>
                </div>
              )}
              <div style={{ background: 'rgba(0,102,255,0.05)', border: '1px solid rgba(0,102,255,0.15)', borderRadius: '8px', padding: '12px', fontSize: '12px', color: '#94A3B8' }}>
                {form.role === 'admin' && '👑 Full access — All modules'}
                {form.role === 'manager' && '📊 Dashboard, Inventory, Reports only'}
                {form.role === 'cashier' && '🧾 POS Billing only'}
              </div>
            </div>
            <div style={{ display: 'flex', gap: '12px', marginTop: '24px' }}>
              <button onClick={handleSubmit} style={{ flex: 1, padding: '12px', background: 'linear-gradient(135deg, #0066FF, #0052CC)', color: 'white', border: 'none', borderRadius: '8px', fontSize: '14px', fontWeight: 700, cursor: 'pointer' }}>
                {editUser ? 'Update User' : 'Create User'}
              </button>
              <button onClick={() => { setShowModal(false); setEditUser(null); }} style={{ flex: 1, padding: '12px', background: 'rgba(255,255,255,0.05)', color: 'white', border: '1px solid rgba(255,255,255,0.1)', borderRadius: '8px', fontSize: '14px', cursor: 'pointer' }}>Cancel</button>
            </div>
          </div>
        </div>
      )}

      {showPasswordModal && (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.8)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000, padding: '16px' }}>
          <div style={{ background: '#0D1B2A', border: '1px solid rgba(255,255,255,0.1)', borderRadius: '16px', padding: '32px', width: '100%', maxWidth: '400px' }}>
            <h2 style={{ fontFamily: 'Montserrat', fontSize: '20px', fontWeight: 800, marginBottom: '8px', color: 'white' }}>Reset Password</h2>
            <p style={{ color: '#475569', fontSize: '13px', marginBottom: '24px' }}>For <span style={{ color: '#0066FF', fontWeight: 600 }}>{selectedUser?.name}</span></p>
            <div>
              <label style={{ display: 'block', fontSize: '12px', fontWeight: 600, marginBottom: '6px', color: '#94A3B8' }}>New Password *</label>
              <input type="password" placeholder="Min 6 characters" value={newPassword} onChange={e => setNewPassword(e.target.value)} style={inputStyle} />
            </div>
            <div style={{ display: 'flex', gap: '12px', marginTop: '24px' }}>
              <button onClick={handleResetPassword} style={{ flex: 1, padding: '12px', background: 'linear-gradient(135deg, #F59E0B, #D97706)', color: 'white', border: 'none', borderRadius: '8px', fontSize: '14px', fontWeight: 700, cursor: 'pointer' }}>🔑 Reset</button>
              <button onClick={() => { setShowPasswordModal(false); setNewPassword(''); }} style={{ flex: 1, padding: '12px', background: 'rgba(255,255,255,0.05)', color: 'white', border: '1px solid rgba(255,255,255,0.1)', borderRadius: '8px', fontSize: '14px', cursor: 'pointer' }}>Cancel</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default UserManagement;
